module.exports = __webpack_public_path__ + "static/assets/2e92f84e1c5efb48cce9f87ef0dd829e.png";